<mat-expansion-panel class="box-shadow border-radius-0" #panel>
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">device_hub</mat-icon>
      <span>Pax Connections</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <mat-tab-group dynamicHeight>
      <mat-tab label="Inbound">
        <app-inbound-connections
          [flightState]="flightState"
        ></app-inbound-connections>
      </mat-tab>
      <mat-tab label="Outbound">
        <app-outbound-connections
          [flightState]="flightState"
        ></app-outbound-connections>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</mat-expansion-panel>
